import React from 'react';
import { Link } from 'react-router-dom';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';

export default function DashboardStateChart({ states, loading }) {
  const data = (states || []).slice(0, 8);
  const hasData = data.some((r) => Number(r.count) > 0);

  return (
    <div className="db-card">
      <div className="db-card-header">
        <div className="db-card-title">
          <i className="fas fa-map-location-dot" style={{ color: '#0891B2' }} />
          State distribution
        </div>
        <Link to="/users" className="db-card-link">
          View users
        </Link>
      </div>
      <div className="db-card-body">
        {loading ? (
          <div className="db-skeleton-block" />
        ) : !hasData ? (
          <div className="db-chart-empty">No state data available</div>
        ) : (
          <div className="db-chart-wrap" role="img" aria-label="State distribution chart">
            <ResponsiveContainer width="100%" height={240}>
              <BarChart data={data} margin={{ top: 8, right: 8, left: 0, bottom: 4 }}>
                <XAxis dataKey="state" tick={{ fontSize: 11 }} />
                <YAxis tick={{ fontSize: 11 }} allowDecimals={false} />
                <Tooltip contentStyle={{ fontSize: 12, borderRadius: 8 }} />
                <Bar dataKey="count" fill="#074f78" radius={[6, 6, 0, 0]} maxBarSize={40} />
              </BarChart>
            </ResponsiveContainer>
          </div>
        )}
      </div>
    </div>
  );
}
